import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Accordion, ErrorBoundary } from '@sainsburys-tech/bolt'
import { useMedia } from '@sainsburys-tech/boltui-hooks'

import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import { scrollToAccordion } from '../../helpers/openAccordion'

import Box from '@/components/Box/Box'
import Description from '../../components/Description/Description'

import * as Styled from '../../components/Description/Description.styles'

const ContentSection = ({
  className,
  descriptionId,
  descriptionOptions,
  onAccordionChange,
  children,
  isAccordion,
  accordionOptions,
  showCategoryNumber,
  isMadeToOrder
}) => {
  const showAccordion = isAccordion || useMedia([false, true], false, [`(min-width: 768px)`, `(max-width: 768px)`])
  useEffect(() => {
    if (!showAccordion) {
      onAccordionChange('description', true)
    }
  }, [showAccordion])

  return (
    <section className={className}>
      <ErrorBoundary>
        {!showAccordion && (
          <Box>
            <Description {...descriptionOptions} id={descriptionId} />
          </Box>
        )}
        {showAccordion && (
          <Accordion.Item
            {...accordionOptions}
            as='h3'
            title={<DescriptionHeader />}
            name='description-accordion'
            onClick={(index, show) => {
              onAccordionChange('description', show)
              if (show) {
                scrollToAccordion('#pdp-description', isMadeToOrder)

                // Adobe Analytics Tracking Code
                if (isMadeToOrder) {
                  pushEventAndTrack({
                    eventInfo: {
                      eventName: 'pdp_showMore',
                      eventAction: 'About this product'
                    }
                  })
                } else {
                  pushEventAndTrack({
                    eventInfo: {
                      eventName: 'pdp_productDescExpand',
                      eventAction: 'pdp expand product description accordion'
                    }
                  })
                }
              }
            }}
            noAnimation={!!children}
            data-test='description-accordion'
            index='description-accordion'
            id={descriptionId}
            className='pdp-v2-description-accordion rounded'
          >
            <Description {...descriptionOptions} headerText={null} id={null} showCategoryNumber={showCategoryNumber} />
            {children || <p />}
          </Accordion.Item>
        )}
      </ErrorBoundary>
    </section>
  )
}

const DescriptionHeader = () => (
  <Styled.AcordionHeader data-test='description-header'> About this product </Styled.AcordionHeader>
)

ContentSection.propTypes = {
  className: PropTypes.string,
  descriptionId: PropTypes.string.isRequired,
  descriptionOptions: PropTypes.object.isRequired,
  onAccordionChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  isAccordion: PropTypes.bool,
  accordionOptions: PropTypes.object,
  showCategoryNumber: PropTypes.bool,
  isMadeToOrder: PropTypes.bool
}
export default ContentSection
export { DescriptionHeader }
